import api from '.'

export interface SendRebuttalEventInput<D> {
  debtAmount: number
  eventMessage: D
  eventType: string
  userEmail: string
}

export default async function sendRebuttalEvent<D>(
  data: SendRebuttalEventInput<D>,
) {
  api.post('/rebuttal/event', {
    debt_amount: data.debtAmount,
    event_message: data.eventMessage,
    event_type: data.eventType,
    user_email: data.userEmail,
  })
}
